import md5 from "md5";

import TrackingService from "@services/tracking/tracking.service";
import { EventTypes } from "@services/tracking/types/eventTypes";

import { TypedAnalyticsEvent } from "../types/analyticsEvent";
import {
    PageImpressionAemModel,
    PageImpressionTrackingInfo,
} from "../types/trackingInfo/pageImpressionTrackingInfo";
import { UserTrackingInfo } from "../types/trackingInfo/userTrackingInfo";
import { getJsonPayload } from "./utils";

const getPageInfo = (): PageImpressionTrackingInfo => {
    const pageImpressionElement: HTMLElement | null = document.querySelector(
        '[data-tracking-event="page-impression"]',
    );
    if (pageImpressionElement) {
        const pageInfo: PageImpressionAemModel = getJsonPayload(
            pageImpressionElement,
        );

        return {
            name: pageInfo.name,
            url: pageInfo.url,
            locale: pageInfo.locale,
            language: pageInfo.language,
            category: pageInfo.category,
            type: pageInfo.type,
            timestamp: Date.now(),
        };
    }
    return {
        name: "",
        url: "",
        locale: "",
        language: "",
        category: "",
        type: "",
        timestamp: Date.now(),
    };
};

const getUserInfo = (): UserTrackingInfo => {
    const email = sessionStorage.getItem("customer_email");
    if (email) {
        return {
            loginStatus: true,
            clientID: createUserId(email),
        };
    }

    return {
        loginStatus: false,
    };
};

const createUserId = (email: string) => md5(email);

const trackPageImpression = (): void => {
    const event: TypedAnalyticsEvent<{}> = {
        event: EventTypes.PageImpression,
        payload: {
            eventData: {},
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackPageImpression, getPageInfo, getUserInfo, createUserId };
